<p-drawer [closeOnEscape]="false" [visible]="showProspect()" [showCloseIcon]="false" position="right" [blockScroll]="true" [dismissible]="false" styleClass="w-12 lg:w-9 no-header p-0 prospect-form" [appendTo]="'body'"
  aria-label="prospect-form-sidebar"
  data-testid="prospect-form-sidebar">

  <ng-template #header>
    <!-- Header -->
    <div class="border-bottom-1 border-300 flex align-items-center justify-content-between sticky left-0 top-0 w-full surface-0 z-5" data-testid="prospect-form-header">
      <div class="flex align-items-center">
        <div (click)="closeSidebar()" class="h-2rem w-2rem cursor-pointer surface-200 flex align-items-center justify-content-center"
          aria-label="close-prospect-form"
          data-testid="close-prospect-form">
          <i class="fa fa-times text-xl text-600"></i>
        </div>
        <h5 class="text-sm ml-3 mb-0">{{'Shared.CREATE-PROSPECT.HEADER_ADDPROSPECT' | translate}}</h5>
      </div>
    </div>
  </ng-template>


  <!--Header End-->
  <ng-template #content>
    <form [formGroup]="fg" (submit)="CreateProspectSubmit()" class="text-sm" data-testid="prospect-form">
      <p-toast key="client-toast" (onClose)="hideProspect.emit(clientId() || 0)" [style]="{marginTop: '80px'}" styleClass="custom-toast">
        <ng-template let-message pTemplate="message">
          <div style="text-align: center;">
            {{message.detail}}
            <a href="javascript:void(0);" class="cursor-pointer text-primary" (click)="GoToClientDetails.emit({showClientSidebar: true, clientId: message.data.clientId})">
              {{ message.data.clientName}}
            </a>
          </div>
        </ng-template>
      </p-toast>

      <div class="px-3 text-sm">

        <!-- Tenant Details -->
        @if (formType() === 'contact') {
          <div class="pt-3" data-testid="prospect-tenant-details-section">
            <div class="surface-200 py-2 px-3 border-round font-bold text-sm">{{'Shared.CREATE-PROSPECT.TENANT_DETAILS' | translate}}</div>
            <div class="pt-3">
              <div class="grid md:px-3">
                <div class="col-12">
                  <label for="tenant_id" class="font-medium text-700 text-xs mb-2 block uppercase">
                    {{'Shared.CREATE-PROSPECT.SELECT_TENANT' | translate}}
                    <sup class="p-error">*</sup>
                  </label>
                  @if (!showSkeleton()) {
                    <multi-tenant-list (emittedTenant)="selectTenant($event)" [selectionMode]="'single'"[styleClass]="'w-full h-full border-none header__tenant-list'" />
                    @if (TenantIdControl && TenantIdControl.touched && TenantIdControl.invalid) {
                      <app-error-msg class="md:block p-error" [errors]="TenantIdControl.errors" [fieldLabel]="'Shared.CREATE-PROSPECT.SELECT_TENANT_ERROR' | translate"
                      data-testid="prospect-tenant-error" />
                    }
                  }
                  @if (showSkeleton()) {
                    <p-skeleton width="100%" height="2.15rem" />
                  }
                </div>
              </div>
            </div>
          </div>
        }

        <!-- Personal Details -->
        <div class="pt-3" data-testid="prospect-personal-details-section">
          <div class="surface-200 py-2 px-3 border-round font-bold text-sm">{{'Shared.CREATE-PROSPECT.PERSONAL_DETAILS' | translate}}</div>
          <div class="pt-3">

            <div class="grid md:px-3">
              <div class="col-12 md:col-4">

                <!-- When No Picture is Uploaded -->
                @if (!uploadSuccess()) {
                  <div class="flex align-items-center">
                    <!-- <div (click)="uploadProfilePicture=true" class="flex align-items-center justify-content-center h-4rem w-4rem border-circle border-2 border-300 surface-200 cursor-pointer">
                    <i class="fa fa-camera text-600 text-xl"></i>
                  </div> -->
                  <p-avatar (click)="uploadProfilePicture=true" icon="fa fa-camera text-600 text-xl" size='xlarge' shape="circle" styleClass="cursor-pointer"
                    aria-label="prospect-profile-picture"
                  data-testid="prospect-profile-picture" />
                  <div class="ml-3">
                    <h3 class="text-sm mb-1 font-normal">{{'Shared.CREATE-PROSPECT.UPLOAD_PROFILE_PICTURE' | translate}}</h3>
                    <p class="text-xs mb-0 text-600">{{ 'CreateEditStaff.ACCEPTED_FILE_TYPE' | translate }}: .Jpeg, .PNG, .JPG, .Gif</p>
                  </div>
                </div>
              }
              <!-- When No Picture is Uploaded -->

              <!-- Profile Picture After Upload -->
              @if (uploadSuccess()) {
                <div class="relative w-4rem text-center">
                  <p-avatar [image]="imageBase64 || existingImage" styleClass="w-4rem h-4rem" shape="circle" />
                  <div class="text-primary cursor-pointer fa fa-pencil-alt absolute right top-0 mt-2 -ml-2" (click)="uploadProfilePicture=true"></div>
                </div>
              }
              <!-- Profile Picture After Upload -->

            </div>
            <div class="col-12 md:col-4">
              <label for="full_name" class="font-medium text-700 text-xs mb-2 block uppercase">
                {{'Shared.CREATE-PROSPECT.LABEL_FULLNAME' | translate}}
                <sup class="p-error">*</sup>
              </label>
              @if (!showSkeleton()) {
                <input type="text" pInputText class="w-full" formControlName="full_name" [autocomplete]="false" placeholder="{{'Shared.CREATE-PROSPECT.PLACEHOLDER_NAME' | translate}}" (ngModelChange)="capitalizeInput()"
                  aria-label="prospect-full-name-input"
                  data-testid="prospect-full-name-input"/>
                  @if (NameControl && NameControl.touched && NameControl.invalid) {
                    <app-error-msg class="md:block p-error" [errors]="NameControl.errors" [fieldLabel]="'Shared.CREATE-PROSPECT.NAME' | translate"
                    data-testid="prospect-full-name-error" />
                  }
                }
                @if (showSkeleton()) {
                  <p-skeleton width="100%" height="2.15rem" />
                }
              </div>

              <div class="col-12 md:col-4">
                <label for="emailid" class="font-medium text-700 text-xs mb-2 block uppercase">
                  {{'Shared.CREATE-PROSPECT.LABEL_EMAILID' | translate}}
                  @if (EmailIdControl && EmailIdControl.status === 'INVALID') {
                    <sup class="p-error">*</sup>
                  }
                </label>
                @if (!showSkeleton()) {
                  <input type="email" pInputText class="w-full" formControlName="emailId" [autocomplete]="false" placeholder="name@example.com"
                    aria-label="prospect-email-input"
                    data-testid="prospect-email-input"/>
                    @if (EmailIdControl && EmailIdControl.touched && ((EmailIdControl.errors && EmailIdControl.errors.emailExists) || emailAlreadyExists())) {
                      <div class="p-error mt-2 text-xs">
                        <i class="fa fa-exclamation-circle mr-2"></i>
                        <span>{{'Shared.CREATE-PROSPECT.EMAIL_EXISTS' | translate}}</span>
                        <strong class="underline cursor-pointer" (click)="openClientSidebar(existClientForEmail?.clt_id)">{{existClientForEmail?.clt_full_name}}</strong>
                      </div>
                    }
                    @if (EmailIdControl && EmailIdControl.touched && EmailIdControl.invalid) {
                      <app-error-msg class="md:block p-error" [errors]="EmailIdControl.errors" [fieldLabel]="'Shared.CREATE-PROSPECT.EMAILID' | translate"
                      data-testid="prospect-email-error" />
                    }
                  }
                  @if (showSkeleton()) {
                    <p-skeleton width="100%" height="2.15rem" />
                  }
                </div>

                <div class="col-12 md:col-4">
                  <label class="font-medium text-700 text-xs mb-2 block uppercase" for="mobileno">
                    {{'Shared.CREATE-PROSPECT.LABEL_MOBILENUMBER' | translate}}
                    @if (MobileNoControl && MobileNoControl.status === 'INVALID') {
                      <sup class="p-error">*</sup>
                    }
                  </label>
                  @if (!showSkeleton()) {
                    <ngx-intl-tel-input [cssClass]="(MobileNoControl.invalid && MobileNoControl.touched)?'p-invalid':''"
                      [enableAutoCountrySelect]="false"
                      [enablePlaceholder]="true"
                      [searchCountryFlag]="false"
                      [selectFirstCountry]="false"
                      [selectedCountryISO]="clientMobileNoCountry ? clientMobileNoCountry : tenantCountry"
                      [onlyCountries]="onlyCountries"
                      [maxLength]="15"
                      [phoneValidation]="false"
                      [separateDialCode]="true"
                      formControlName="mobileNo"
                      aria-label="prospect-mobile-input"
                      data-testid="prospect-mobile-input" />
                    @if (MobileNoControl && MobileNoControl.touched && ((MobileNoControl.errors && MobileNoControl.errors.mobileExists) || mobileAlreadyExists())) {
                      <div class="p-error mt-2 text-xs">
                        <i class="fa fa-exclamation-circle mr-2"></i>
                        <span>{{'Shared.CREATE-PROSPECT.MOBILE_EXISTS' | translate}}</span>
                        <strong class="underline cursor-pointer" (click)="openClientSidebar(existClientForMobile?.clt_id)">{{existClientForMobile?.clt_full_name}}</strong>
                      </div>
                    }
                    @if (MobileNoControl && MobileNoControl.touched && MobileNoControl.invalid) {
                      <app-error-msg class="md:block p-error" [errors]="MobileNoControl.errors" [fieldLabel]="'Shared.CREATE-PROSPECT.MOBILENO' | translate"
                      data-testid="prospect-mobile-error" />
                    }
                  }
                  @if (showSkeleton()) {
                    <p-skeleton width="100%" height="2.15rem" />
                  }
                </div>

                <div class="col-12 md:col-8">
                  <label class="font-medium text-700 text-xs mb-2 block uppercase" for="gender">
                    {{'Shared.CREATE-PROSPECT.LABEL_GENDER' | translate}}
                    <sup class="p-error">*</sup>
                  </label>
                  @if (!showSkeleton()) {
                    <p-select
                      [options]="genderOptions()"
                      formControlName="selectedGender"
                      (onChange)="SetGenderOnChange($event)"
                      styleClass="w-full text-sm"
                      [placeholder]="'CreateEditStaff.GENDER' | translate"
                      aria-label="prospect-gender-dropdown"
                      data-testid="prospect-gender-dropdown">
                      <ng-template pTemplate="selectedItem">
                        @if (SelectedGender?.value) {
                          <div class="text-sm">{{SelectedGender.value}}</div>
                        }
                      </ng-template>
                      <ng-template let-gender pTemplate="item">
                        <div class="text-sm">{{gender}}</div>
                      </ng-template>
                    </p-select>
                    @if (SelectedGender.touched && SelectedGender.invalid) {
                      <app-error-msg styleClass="md:block p-error" [errors]="SelectedGender.errors" [fieldLabel]="'CreateEditStaff.GENDER' | translate"
                        data-testid="prospect-gender-error" />
                    }
                  }
                  @if (showSkeleton()) {
                    <p-skeleton width="100%" height="2.15rem" />
                  }
                </div>
              </div>
            </div>
          </div>
          <!-- Marketing Details -->
          <div class="pt-3">
              <div class="surface-200 py-2 px-3 border-round font-bold text-sm">
                {{'Shared.CREATE-PROSPECT.HEADER_MARKETING' | translate}}
              </div>
              <div class="pb-2 mb-1 pt-3">
                <div class="grid justify-content-between px-3">
                  <div class="col-12 md:col-8 xl:col-6">
                    <label class="font-medium text-700 text-xs mb-2 block uppercase" for="channel">
                      {{'EDIT_CLIENT_PROFILE.CHANNEL' | translate}}
                      <sup class="p-error">*</sup>
                    </label>
                    @if (!showSkeleton()) {
                      <div class="p-buttonset white-space-nowrap hidden md:flex">
                        @for (channelOption of channelCollection; track channelOption) {
                          <button
                            type="button"
                            class="p-button-primary border-right-1 border-white text-sm"
                            [ngClass]="{'p-button-primary': channelOption.channel === ChannelControl.value?.channel,'p-button-secondary': channelOption.channel !== ChannelControl.value?.channel}"
                            (click)="ChannelControl.setValue(channelOption)"
                            pButton
                            pRipple
                            [label]="channelOption.channel"
                            [attr.aria-label]="'select-prospect-channel-' + channelOption.channel"
                            [attr.data-testid]="'select-prospect-channel-' + channelOption.channel">
                          </button>
                        }
                      </div>
                      <!-- For Mobile -->
                      <p-select [options]="channelCollection" formControlName="channel" optionLabel="channel" placeholder="{{'EDIT_CLIENT_PROFILE.CHANNEL' | translate}}" styleClass="w-full text-sm md:hidden"
                        aria-label="prospect-channel-dropdown-mobile"
                        data-testid="prospect-channel-dropdown-mobile">
                        <ng-template pTemplate="selectedItem">
                          @if (ChannelControl && ChannelControl.value) {
                            <div class="text-sm">
                              {{ChannelControl.value.channel}}
                            </div>
                          }
                        </ng-template>
                        <ng-template let-channel pTemplate="item">
                          <div class="text-sm">{{channel.channel}}</div>
                        </ng-template>
                      </p-select>
                      @if (ChannelControl && ChannelControl.touched && ChannelControl.invalid) {
                        <app-error-msg class="md:block p-error" [errors]="ChannelControl.errors" [fieldLabel]="'EDIT_CLIENT_PROFILE.CHANNEL' | translate"
                        data-testid="prospect-channel-error" />
                      }
                    }
                    @if (showSkeleton()) {
                      <p-skeleton width="100%" height="2.15rem" />
                    }
                  </div>
                  <div class="col-12 md:col-4 xl:col-3">
                    <label class="font-medium text-700 text-xs mb-2 block uppercase" for="source">
                      {{'EDIT_CLIENT_PROFILE.ENQUIRY_SOURCE' | translate}}
                      <sup class="p-error">*</sup>
                    </label>
                    @if (!showSkeleton()) {
                      @if (!showOtherSourceTextBox()) {
                        <p-select [options]="Source" formControlName="source" placeholder="{{'EDIT_CLIENT_PROFILE.ENQUIRY_SOURCE' | translate}}" styleClass="w-full text-sm"
                          aria-label="prospect-source-dropdown"
                          data-testid="prospect-source-dropdown" />
                      }
                      @if (showOtherSourceTextBox()) {
                        <input type="text" formControlName="source" pInputText class="w-full text-sm" placeholder="{{'EDIT_CLIENT_PROFILE.OTHER_SOURCE' | translate}}"
                          aria-label="prospect-other-source-input"
                          data-testid="prospect-other-source-input">
                      }
                      @if (SourceControl && SourceControl.touched && SourceControl.invalid) {
                        <app-error-msg class="md:block p-error" [errors]="SourceControl.errors" [fieldLabel]="'Shared.CREATE-PROSPECT.ENQUIRYSOURCE' | translate"
                        data-testid="prospect-source-error" />
                      }
                    }
                    @if (showSkeleton()) {
                      <p-skeleton width="100%" height="2.15rem" />
                    }
                  </div>
                  <div class="col-12 xl:col-3">
                    <label class="font-medium text-700 text-xs mb-2 block white-space-nowrap uppercase" for="clientid">
                      {{'EDIT_CLIENT_PROFILE.REFERED_BY' | translate}}
                    </label>
                    @if (!showSkeleton()) {
                      <mini-search class="w-full text-sm" [disabledctrl]="clientData() ? true : false" [showSelected]="true" [clientId]="referredBy()" (clients)="GetClientReferrel($event)" (removedClient)="removeClient($event)"
                        aria-label="prospect-referred-by-search"
                        data-testid="prospect-referred-by-search" />
                    }
                    @if (showSkeleton()) {
                      <p-skeleton width="100%" height="2.15rem" />
                    }
                  </div>
                  <!-- Promotional Preference -->
                  <div class="col-12">
                    <label for="promotionalPreference" class="font-medium text-700 text-xs mb-2 block uppercase">
                      {{'Shared.CREATE-PROSPECT.LABEL_PROMOTIONALPREFERENCE' | translate}}
                    </label>
                    <div class="grid text-sm w-full">
                      @for (preferenceOption of promotionalPreferenceCollection; track preferenceOption.code) {
                        <div class="col-12 sm:col-6 xl:col-3">
                          @if (!showSkeleton()) {
                            <div class="flex align-items-center justify-content-between gap-2 w-full prospect-promotional-preference-row">
                              <div class="flex align-items-center min-w-0 flex-1">
                                <i [class]="preferenceOption.icon + ' text-base mr-2 flex-shrink-0'"></i>
                                <span class="line-height-3">{{ preferenceOption.name }}</span>
                              </div>
                              <p-toggleSwitch
                                styleClass="flex-shrink-0"
                                [formControlName]="getPromotionalPreferenceControlName(preferenceOption)"
                                (onChange)="PromotionalPreferenceToTrue(preferenceOption)"
                                [attr.aria-label]="'toggle-prospect-promotional-preference-' + getPromotionalPreferenceControlName(preferenceOption)"
                                [attr.data-testid]="'toggle-prospect-promotional-preference-' + getPromotionalPreferenceControlName(preferenceOption)" />
                            </div>
                          }
                          @if (showSkeleton()) {
                            <p-skeleton width="100%" height="1.75rem" />
                          }
                        </div>
                      }
                    </div>
                    @if (PromotionalPreferenceControl && PromotionalPreferenceControl.touched && PromotionalPreferenceControl.invalid) {
                      <app-error-msg class="md:block p-error"
                        [errors]="PromotionalPreferenceControl.errors"
                        [fieldLabel]="'Shared.CREATE-PROSPECT.LABEL_PROMOTIONALPREFERENCE' | translate"
                         />
                    }
                  </div>
                  <!-- Promotional Preference -->
                  <!-- Sales Representative -->
                  <div class="col-12 md:col-6">
                    <label for="newRepresentative" class="font-medium text-700 text-xs mb-2 block uppercase">
                      {{'Shared.CREATE-PROSPECT.SALES_REP' | translate}}
                      <sup class="p-error">*</sup>
                    </label>
                    @if (!showSkeleton()) {
                      <staff-selector [formGroup]="fg" [controlName]="NewRepresentative" [filterstaff]="staffIds$" [claims]="claims" [id]="selectedClientRep$" [styleClass]="'w-full text-sm py-0 align-items-center'"
                        aria-label="prospect-sales-rep-selector"
                        data-testid="prospect-sales-rep-selector" />
                      @if (NewRepresentative && NewRepresentative.touched && NewRepresentative.invalid) {
                        <app-error-msg class="md:block p-error" [errors]="NewRepresentative.errors" [fieldLabel]="'Shared.CREATE-PROSPECT.SALES_REP' | translate"
                          data-testid="prospect-sales-rep-error" />
                      }
                    }
                    @if (NewRepresentative && NewRepresentative.disabled) {
                      <span class="text-xs">
                        {{'Shared.CREATE-PROSPECT.CLIENT_REP_CHANGE_INFO' | translate}}
                      </span>
                    }
                    @if (showSkeleton()) {
                      <p-skeleton width="100%" height="2.15rem" />
                    }
                  </div>
                  <!-- Sales Representative -->
                </div>
              </div>
          </div>
          <!-- Marketing Details -->

          <!-- Profile Linking -->
          <div>
                <div class="surface-200 py-2 px-3 border-round font-bold text-sm">
                  {{'Shared.CREATE-PROSPECT.HEADER_PROFILE_LINKING' | translate}}
                </div>
                <div class="p-3">
                  <div class="grid align-items-center">
                    <div class="col-12 md:col-4 md:pr-3 flex align-items-center justify-content-between">
                      <div class="mr-5">{{'Shared.CREATE-PROSPECT.LABEL_LINK_TO_EXISTING' | translate}}</div>
                      @if (!showSkeleton()) {
                        <p-toggleSwitch formControlName="is_child"
                          aria-label="toggle-prospect-profile-linking"
                          data-testid="toggle-prospect-profile-linking" />
                      }
                      @if (showSkeleton()) {
                        <p-skeleton width="3rem" height="1.75rem" />
                      }
                    </div>
                    @if (fg.get('is_child')?.value) {
                      <div class="col-12 md:col-4">
                        <label for="parent_client" class="font-medium text-700 text-xs mb-2 block uppercase">
                          {{'Shared.CREATE-PROSPECT.LABEL_SEARCH_PROFILE' | translate}}
                          <sup class="p-error">*</sup>
                        </label>
                        @if (!showSkeleton()) {
                          <mini-search class="w-full text-sm" [readonly]="false" [showSelected]="true" (clients)="getParentClientId($event)" (removedClient)="removeParentClient($event)"
                            aria-label="prospect-parent-client-search"
                            data-testid="prospect-parent-client-search" />
                          @if (LinkedClientIdControl && LinkedClientIdControl.touched && LinkedClientIdControl.invalid) {
                            <app-error-msg class="md:block p-error" [errors]="LinkedClientIdControl.errors" [fieldLabel]="'Shared.CREATE-PROSPECT.LINK_TO_EXISTING' | translate"
                              data-testid="prospect-link-error" />
                          }
                        }
                        @if (showSkeleton()) {
                          <p-skeleton width="100%" height="2.15rem" />
                        }
                      </div>
                    }
                    @if (fg.get('is_child')?.value) {
                      <div class="col-12 md:col-4">
                        <label for="relation" class="font-medium text-700 text-xs mb-2 block uppercase">
                          {{'Shared.CREATE-PROSPECT.LABEL_RELATIONSHIP' | translate}}
                          <sup class="p-error">*</sup>
                        </label>
                        @if (!showSkeleton()) {
                          <p-select [options]="relationships" formControlName="relation" [placeholder]="'ADMIN.COMMON.SELECT' | translate" optionLabel="name" styleClass="w-full"
                            aria-label="prospect-relationship-dropdown"
                            data-testid="prospect-relationship-dropdown">
                            <ng-template pTemplate="selectedItem">
                              @if (RelationshipControl && RelationshipControl.value) {
                                <div class="text-sm">
                                  {{RelationshipControl.value.name}}
                                </div>
                              }
                            </ng-template>
                            <ng-template let-relationship pTemplate="item">
                              <div class="text-sm">{{relationship.name}}</div>
                            </ng-template>
                          </p-select>
                          @if (RelationshipControl && RelationshipControl.touched && RelationshipControl.invalid) {
                            <app-error-msg class="md:block p-error" [errors]="RelationshipControl.errors" [fieldLabel]="'Shared.CREATE-PROSPECT.RELATIONSHIP' | translate"
                              data-testid="prospect-relationship-error" />
                          }
                        }
                        @if (showSkeleton()) {
                          <p-skeleton width="100%" height="2.15rem" />
                        }
                      </div>
                    }
                  </div>
                </div>
              </div>
          </div>
          <!-- Profile Linking -->

          <!-- Additional Information -->
            <div>
              <div [ngClass]="showAdditionalInformation ? '' :'mb-4'" (click)="showAdditionalInformation=!showAdditionalInformation" class="cursor-pointer surface-200 py-2 px-3 border-round font-bold text-sm flex align-items-center"
                aria-label="toggle-additional-information"
                data-testid="toggle-additional-information">
                <span>{{'Shared.CREATE-PROSPECT.HEADER_ADDITIONAL_INFO' | translate}}</span>
                <i class="fa text-primary ml-3" [ngClass]="showAdditionalInformation ? 'fa-chevron-circle-up' :'fa-chevron-circle-down'"></i>
              </div>
              @if (showAdditionalInformation) {
                <div class="p-3">
                  <div class="grid align-items-center">
                    <!-- Date of Birth -->
                    <div class="col-12 md:col-4">
                      <label for="dateOfBirth" class="font-medium text-700 text-xs mb-2 block uppercase" data-testid="prospect-dob-label">
                        {{'EDIT_CLIENT_PROFILE.DATE_OF_BIRTH' | translate}}
                      </label>
                      @if (!showSkeleton()) {
                        <p-datepicker formControlName="dateOfBirth" [showIcon]="true" dateFormat="dd/mm/yy" [maxDate]="minDate" styleClass="w-full" placeholder="{{'EDIT_CLIENT_PROFILE.DATE_OF_BIRTH' | translate}}"
                          aria-label="prospect-date-of-birth"
                          data-testid="prospect-date-of-birth" />
                        @if (DateOfBirthControl && DateOfBirthControl.touched && DateOfBirthControl.invalid) {
                          <app-error-msg class="md:block p-error" [errors]="DateOfBirthControl.errors" [fieldLabel]="'EDIT_CLIENT_PROFILE.DATE_OF_BIRTH' | translate"
                            data-testid="prospect-dob-error" />
                        }
                      }
                      @if (showSkeleton()) {
                        <p-skeleton width="100%" height="2.15rem" />
                      }
                    </div>
                    <!-- Emergency Contact Name -->
                    <div class="col-12 md:col-4">
                      <label for="emergencyContact"   class="font-medium text-700 text-xs mb-2 block uppercase" data-testid="prospect-emergency-contact-label">
                        {{'EDIT_CLIENT_PROFILE.EMERGENCY_CONTACT_NAME' | translate}}
                      </label>
                      @if (!showSkeleton()) {
                        <input type="text" pInputText class="w-full" formControlName="emergencyContact" [placeholder]="'EDIT_CLIENT_PROFILE.EMERGENCY_CONTACT_NAME' | translate"
                          aria-label="prospect-emergency-contact-input"
                          data-testid="prospect-emergency-contact-input">
                          @if (EmergencyContactControl && EmergencyContactControl.touched && EmergencyContactControl.invalid) {
                            <app-error-msg class="md:block p-error" [errors]="EmergencyContactControl.errors" [fieldLabel]="'EDIT_CLIENT_PROFILE.EMERGENCY_CONTACT_NAME' | translate"
                              data-testid="prospect-emergency-contact-error" />
                          }
                        }
                        @if (showSkeleton()) {
                          <p-skeleton width="100%" height="2.15rem" />
                        }
                      </div>
                      <!-- Emergency Contact Number -->
                      <div class="col-12 md:col-4">
                        <label for="emergencyNumber" class="font-medium text-700 text-xs mb-2 block uppercase" data-testid="prospect-emergency-number-label">
                          {{'EDIT_CLIENT_PROFILE.EMERGENCY_CONTACT_NO' | translate}}
                        </label>
                        @if (!showSkeleton()) {
                          <ngx-intl-tel-input [cssClass]="(EmergencyNumberControl.invalid && EmergencyNumberControl.touched)?'p-invalid':''"
                            [enableAutoCountrySelect]="false"
                            [enablePlaceholder]="true"
                            [searchCountryFlag]="false"
                            [selectFirstCountry]="false"
                            [selectedCountryISO]="tenantCountry"
                            [onlyCountries]="onlyCountries"
                            [maxLength]="15"
                            [phoneValidation]="true"
                            [separateDialCode]="true"
                            formControlName="emergencyNumber"
                            aria-label="prospect-emergency-number-input"
                            data-testid="prospect-emergency-number-input" />
                          @if (EmergencyNumberControl && EmergencyNumberControl.touched && EmergencyNumberControl.invalid) {
                            <app-error-msg class="md:block p-error" [errors]="EmergencyNumberControl.errors" [fieldLabel]="'EDIT_CLIENT_PROFILE.EMERGENCY_CONTACT_NO' | translate"
                              data-testid="prospect-emergency-number-error" />
                          }
                        }
                        @if (showSkeleton()) {
                          <p-skeleton width="100%" height="2.15rem" />
                        }
                      </div>
                      <!-- Second Mobile Number -->
                      <div class="col-12 md:col-4">
                        <label for="secondMobileNo" class="font-medium text-700 text-xs mb-2 block uppercase" data-testid="prospect-second-mobile-label">
                          {{'Shared.CREATE-PROSPECT.LABEL_SECOND_MOBILE' | translate}}
                        </label>
                        @if (!showSkeleton()) {
                          <ngx-intl-tel-input [cssClass]="(SecondMobileNoControl.invalid && SecondMobileNoControl.touched)?'p-invalid':''"
                            [enableAutoCountrySelect]="false"
                            [enablePlaceholder]="true"
                            [searchCountryFlag]="false"
                            [selectFirstCountry]="false"
                            [selectedCountryISO]="tenantCountry"
                            [onlyCountries]="onlyCountries"
                            [maxLength]="15"
                            [phoneValidation]="true"
                            [separateDialCode]="true"
                            formControlName="secondMobileNo"
                            aria-label="prospect-second-mobile-input"
                            data-testid="prospect-second-mobile-input" />
                        }
                        @if (showSkeleton()) {
                          <p-skeleton width="100%" height="2.15rem" />
                        }
                      </div>
                      <!-- Preferred Language -->
                      <div class="col-12 md:col-4">
                          <label for="preferredLanguage" class="font-medium text-700 text-xs mb-2 block uppercase" data-testid="prospect-preferred-language-label">
                            {{'Shared.CREATE-PROSPECT.LABEL_PREFERRED_LANGUAGE' | translate}}
                          </label>
                          @if (!showSkeleton()) {
                            <p-select [options]="supportedLanguages()" optionLabel="LANG_ABBRE" styleClass="text-sm w-full" formControlName="preferredLanguage" [placeholder]="'common.PLACEHOLDER.SELECT' | translate"
                              aria-label="prospect-preferred-language-dropdown"
                              data-testid="prospect-preferred-language-dropdown">
                              @if (PreferedLanguageFormControl && PreferedLanguageFormControl.value) {
                                <ng-template pTemplate="selectedItem">
                                  <div class="text-sm">{{PreferedLanguageFormControl?.value?.LANG_ABBRE}}</div>
                                </ng-template>
                              }
                              <ng-template let-lang pTemplate="item">
                                <div class="text-sm">{{lang.LANG_ABBRE}}</div>
                              </ng-template>
                            </p-select>
                          }
                          @if (showSkeleton()) {
                            <p-skeleton width="100%" height="2.15rem" />
                          }
                        </div>
                      <!-- Nationality -->
                      <div class="col-12 md:col-4">
                        <label for="nationality" class="font-medium text-700 text-xs mb-2 block uppercase" data-testid="prospect-nationality-label">
                          {{'Shared.CREATE-PROSPECT.LABEL_NATIONALITY' | translate}}
                        </label>
                        @if (!showSkeleton()) {
                          <p-select 
                            [options]="nationalities()" 
                            optionLabel="nationality" 
                            optionValue="nationality"
                            styleClass="text-sm w-full" 
                            formControlName="nationality" 
                            [placeholder]="'common.PLACEHOLDER.SELECT' | translate"
                            [filter]="true"
                            filterBy="nationality"
                            [showClear]="true"
                            aria-label="prospect-nationality-dropdown"
                            data-testid="prospect-nationality-dropdown">
                            @if (NationalityControl && NationalityControl.value) {
                              <ng-template pTemplate="selectedItem">
                                <div class="text-sm">{{NationalityControl.value}}</div>
                              </ng-template>
                            }
                            <ng-template let-nationality pTemplate="item">
                              <div class="text-sm">{{nationality.nationality}}</div>
                            </ng-template>
                          </p-select>
                        }
                        @if (showSkeleton()) {
                          <p-skeleton width="100%" height="2.15rem" />
                        }
                      </div>
                      <!-- Organization -->
                      @if (showClientOrganizationLink()) {
                        <div class="col-12 md:col-4">
                          <label for="organisation" class="font-medium text-700 text-xs mb-2 block uppercase" data-testid="prospect-organization-label">
                            {{'Shared.CREATE-PROSPECT.ORGANIZATION' | translate}}
                          </label>
                          @if (!showSkeleton()) {
                            <p-select [options]="organizations()" formControlName="organisation" optionLabel="name" placeholder="{{'Shared.CREATE-PROSPECT.PLACEHOLDER_ORGANIZATION' | translate}}" filterBy="name" styleClass="w-full text-sm" [showClear]="true"
                              aria-label="prospect-organization-dropdown"
                              data-testid="prospect-organization-dropdown">
                              <ng-template let-organization pTemplate="item">
                                <div class="text-sm">{{organization.name}}</div>
                              </ng-template>
                            </p-select>
                          }
                          @if (showSkeleton()) {
                            <p-skeleton width="100%" height="2.15rem" />
                          }
                        </div>
                      }
                     
                      <!-- Address -->
                      <div class="col-12 md:col-8">
                        <label for="address" class="font-medium text-700 text-xs mb-2 block uppercase" data-testid="prospect-address-label">
                          {{'Shared.CREATE-PROSPECT.LABEL_ADDRESS' | translate}}
                        </label>
                        @if (!showSkeleton()) {
                          <input type="text" formControlName="address" pInputText class="w-full text-sm" placeholder="{{'Shared.CREATE-PROSPECT.LABEL_ADDRESS' | translate}}"
                            aria-label="prospect-address-input"
                            data-testid="prospect-address-input">
                          }
                          @if (showSkeleton()) {
                            <p-skeleton width="100%" height="2.15rem" />
                          }
                        </div>

                         <!-- Pin Code -->
                      <div class="col-12 md:col-4">
                        <label for="address_pin_code" class="font-medium text-700 text-xs mb-2 block uppercase" data-testid="prospect-pincode-label">
                          {{'Shared.CREATE-PROSPECT.LABEL_PINCODE' | translate}}
                        </label>
                        @if (!showSkeleton()) {
                          <p-inputNumber formControlName="address_pin_code" class="w-full text-sm" styleClass="w-full text-sm" [maxlength]="10" [format]="false"
                            aria-label="prospect-pincode-input"
                            data-testid="prospect-pincode-input" />
                        }
                        @if (showSkeleton()) {
                          <p-skeleton width="100%" height="2.15rem" />
                        }
                      </div>

                        <!-- National ID -->
                        <div class="col-12 md:col-4">
                          @if (getNationalityLocalization() | async; as nationalid) {
                            <label for="national_id" class="font-medium text-700 text-xs mb-2 block uppercase" data-testid="prospect-national-id-label">
                              {{ nationalid.label | translate}}
                            </label>
                          }
                          @if (!showSkeleton()) {
                            <input type="text" class="w-full text-sm" pInputText placeholder="" formControlName="national_id"
                              aria-label="prospect-national-id-input"
                              data-testid="prospect-national-id-input">
                              @if (NationalIdControl && NationalIdControl.touched && NationalIdControl.invalid && getNationalityLocalization() | async; as nationalid) {
                                <app-error-msg class="md:block p-error" [errors]="NationalIdControl.errors" [fieldLabel]=" nationalid.label | translate"
                                  data-testid="prospect-national-id-error" />
                              }
                            }
                            @if (showSkeleton()) {
                              <p-skeleton width="100%" height="2.15rem" />
                            }
                          </div>
                          <!-- Tax Number -->
                          <div class="col-12 md:col-4">
                            <label for="taxNumber" class="font-medium text-700 text-xs mb-2 block uppercase" data-testid="prospect-tax-number-label">
                              {{'Shared.CREATE-PROSPECT.LABEL_TAX' | translate}}
                            </label>
                            @if (!showSkeleton()) {
                              <input type="text" class="w-full text-sm" pInputText placeholder="" formControlName="taxNumber"
                                aria-label="prospect-tax-number-input"
                                data-testid="prospect-tax-number-input">
                              }
                              @if (showSkeleton()) {
                                <p-skeleton width="100%" height="2.15rem" />
                              }
                            </div>
                            <!-- Migration ID -->
                            <div class="col-12 md:col-4">
                              <label for="migrationId" class="font-medium text-700 text-xs mb-2 block uppercase" data-testid="prospect-migration-id-label">
                                {{'Shared.CREATE-PROSPECT.LABEL_MIGRATION' | translate}}
                              </label>
                              @if (!showSkeleton()) {
                                <input type="text" class="w-full text-sm" pInputText placeholder="" formControlName="migrationId"
                                  aria-label="prospect-migration-id-input"
                                  data-testid="prospect-migration-id-input">
                                }
                                @if (showSkeleton()) {
                                  <p-skeleton width="100%" height="2.15rem" />
                                }
                              </div>
                              <!-- Notes -->
                              <div class="col-12">
                                <label for="notes" class="font-medium text-700 text-xs mb-2 block uppercase" data-testid="prospect-notes-label">
                                  {{'Shared.CREATE-PROSPECT.LABEL_NOTES' | translate}}
                                </label>
                                @if (!showSkeleton()) {
                                  <textarea pTextarea formControlName="notes" class="w-full h-6rem" placeholder="{{'Shared.CREATE-PROSPECT.LABEL_NOTES' | translate}}"
                                    aria-label="prospect-notes-textarea"
                                    data-testid="prospect-notes-textarea">
                                  </textarea>
                                }
                                @if (showSkeleton()) {
                                  <p-skeleton width="100%" height="6rem" />
                                }
                              </div>
                              <!-- Medical Alert -->
                              <div class="col-12">
                                <label for="medicalAlert" class="font-medium text-700 text-xs mb-2 block uppercase" data-testid="prospect-medical-alert-label">
                                  {{'EDIT_CLIENT_PROFILE.MEDICAL_ALERT' | translate}}
                                </label>
                                @if (!showSkeleton()) {
                                  <textarea pTextarea formControlName="medicalAlert" class="w-full" placeholder="{{'EDIT_CLIENT_PROFILE.MEDICAL_ALERT' | translate}}"
                                    aria-label="prospect-medical-alert-textarea"
                                    data-testid="prospect-medical-alert-textarea">
                                  </textarea>
                                  @if (MedicalAlertControl && MedicalAlertControl.touched && MedicalAlertControl.invalid) {
                                    <app-error-msg class="md:block p-error" [errors]="MedicalAlertControl.errors" [fieldLabel]="'EDIT_CLIENT_PROFILE.MEDICAL_ALERT' | translate"
                                      data-testid="prospect-medical-alert-error" />
                                  }
                                }
                                @if (showSkeleton()) {
                                  <p-skeleton width="100%" height="2.15rem" />
                                }
                              </div>
                            </div>
                          </div>
                        }
                      </div>
                      <!-- Additional Information -->

                      <!-- Create Opportunity Section -->
                      @if (formType() === 'prospect' && formEvent() === 'create') {
                        <create-opportunity [parentForm]="fg"
                          [tenantId]="selectedTenant"
                          aria-label="create-opportunity-section"
                          data-testid="create-opportunity-section" />
                      }
                      <!-- Walk-in Tour Section -->
                      @if (formType() === 'walk-in-tour' && formEvent() === 'create') {
                        <walk-in-tour [parentForm]="fg"
                          [staffList]="staffIds()"
                          aria-label="walk-in-tour-section"
                          data-testid="walk-in-tour-section" />
                      }
                      <!-- Walk-in Trial Section -->
                      @if (formType() === 'walk-in-trial' && formEvent() === 'create') {
                        <walk-in-trial [parentForm]="fg"
                          [staffList]="staffIds()"
                          [classList]="classList"
                          aria-label="walk-in-trial-section"
                          data-testid="walk-in-trial-section" />
                      }

                    <!-- Footer -->
                    <div class="border-top-1 border-300 flex align-items-center justify-content-between sticky bottom-0 top-0 w-full surface-0 z-5 py-2 px-3" data-testid="prospect-form-footer">
                      <p-button [label]="'EDIT_CLIENT_PROFILE.CANCEL' | translate" (onClick)="hideProspect.emit(clientId() || 0)" styleClass="text-sm p-button-link"
                        aria-label="cancel-prospect-form"
                        data-testid="cancel-prospect-form" />
                      <p-button [label]="getbuttonText() | translate" type="submit" [loading]="isFormSubmitting()" [disabled]="setBtnDisbale()" styleClass="text-sm"
                        aria-label="submit-prospect-form"
                        data-testid="submit-prospect-form" />
                    </div>

                  </form>

                </ng-template>

              </p-drawer>

              <!-- Upload Profile Picture Modal -->
              <p-dialog [visible]="uploadProfilePicture" [resizable]="false" appendTo="body" [modal]="true" [breakpoints]="{'767px': '100vw'}" [style]="{width: '500px'}" styleClass="no-header-modal"
                aria-label="upload-profile-picture-dialog"
                data-testid="upload-profile-picture-dialog">
                <ng-template pTemplate="header" styleClass="hidden" />
                <ng-template pTemplate="content" styleClass="p-0">
                  <div class="p-3">
                    <div class="relative border-2 border-dashed border-300 border-round p-5 text-center" data-testid="profile-picture-dropzone-container">
                      <div class="flex flex-column align-items-center justify-content-center" data-testid="profile-picture-upload-content">
                        <i class="fa fa-upload text-600 text-4xl mr-3"></i>
                        <div>
                          <p class="text-sm md:text-base line-height-1 my-1" data-testid="profile-picture-upload-text">
                            {{ 'CreateEditStaff.DRAG_DROP' | translate }} <span class="text-primary">{{ 'CreateEditStaff.BROWSE' | translate }}</span>
                          </p>
                          <p class="text-xs md:text-sm mb-0 text-600" data-testid="profile-picture-file-types">{{ 'CreateEditStaff.ACCEPTED_FILE_TYPE' | translate }}: .Jpeg, .PNG, .JPG, .Gif</p>
                        </div>
                      </div>
                      <ngx-file-drop class="opacity-0 absolute w-full h-full top-0 left-0 z-1 cursor-pointer" dropZoneLabel="Drop files here" (onFileDrop)="handleFileSelect($event)" [accept]="'.png,.jpg,.jpeg,.gif'"
                        aria-label="profile-picture-dropzone"
                        data-testid="profile-picture-dropzone">
                        <ng-template ngx-file-drop-content-tmp let-openFileSelector="openFileSelector">
                          <div (click)="openFileSelector()" class="w-full h-full absolute left-0 top-0"></div>
                        </ng-template>
                      </ngx-file-drop>
                    </div>
                  </div>
                  <!-- Footer -->
                  <div class="p-3 flex justify-content-between align-items-center border-top-1 border-300">
                    <button pButton pRipple type="button" label="Cancel" class="p-button-text text-sm" (click)="saveProfilePicture(false)"
                      aria-label="cancel-profile-picture-upload"
                      data-testid="cancel-profile-picture-upload">
                    </button>
                    <button pButton pRipple type="button" label="Save Profile Picture" class="text-sm" (click)="saveProfilePicture(true)"
                      aria-label="save-profile-picture-upload"
                      data-testid="save-profile-picture-upload">
                    </button>
                  </div>
                  <!-- Footer -->
                </ng-template>
              </p-dialog>

              <app-lost-deal [showDailog]="showChooseReason()" (closeMainDailog)="closeLostDeal($event)" [lostDealInfo]="lostDealItemInfo()"
                aria-label="lost-deal-dialog"
                data-testid="lost-deal-dialog" />

